<script setup lang="ts">
definePageMeta({
  auth: true,
})

const { navigation } = useAccount()
</script>

<template>
  <div class="mx-auto max-w-7xl pb10 pb16 lg:px8 lg:py12">
    <div class="lg:grid lg:grid-cols-12 lg:gap-x-5">
      <aside class="px-2 py-6 lg:col-span-3 lg:px-0 lg:py-0 sm:px-6">
        <nav class="relative space-y-1">
          <NavItem
            v-for="(navItem, index) in navigation"
            :key="index"
            v-bind="navItem"
            :class="{
              'bg-slate-100 text-slate-900 border-orange-500 after:absolute after:content-[\'\'] after:bg-orange-500 after:h6 after:w1 after:left-[calc(8px*-1)] after:rounded-full': navItem.active,
              'text-slate-600 hover:bg-slate-50 hover:text-slate-900': !navItem.active,
            }"
          >
            {{ navItem.label }}
          </NavItem>
        </nav>
      </aside>

      <div class="lg:col-span-9 space-y-6 lg:px-0 sm:px-6">
        <NuxtPage />
      </div>
    </div>
  </div>
</template>
